<template>
	<div class="footer-container">
		<div class="footer-content" :class="[type === 'admin' ? 'admin' : 'ecp']">
			<p style="margin-bottom: 30px;">
				<span>{{config.copyright}}</span>
				<a target="_Blank" style="color: #676767;margin-left: 15px;text-decoration: none;">ICP证：{{config.message_sign}}</a>
			</p>
		</div>
	</div>
</template>

<script>
    import LoginFooter from './login-footer';
    export default LoginFooter;
</script>

<style lang="scss" scoped>
	.footer-container {
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		margin: auto;

		.admin {
			color: #AEBDC8;
		}
		.ecp {
			color: #676767;
		}
	}
</style>
